import { BaseApi } from './api'
import { AccessTokenResponse, AuthResponse } from './models/auth'

const authApi = {
  getAccessToken({ code, requestUri }: { code: string; requestUri: string }) {
    return BaseApi.get<AccessTokenResponse>('/v1/accesstoken', {
      params: { code, request_uri: requestUri },
      safeErrorStatus: [401],
    })
  },

  me(token: string) {
    return BaseApi.get<AuthResponse>('/v1/me', { params: { accountConnectToken: token }, safeErrorStatus: [401] })
  },

  refreshToken(token: string) {
    return BaseApi.get<string>('/v1/refreshtoken', { params: { refreshToken: token }, safeErrorStatus: [401] })
  },
}

export default authApi
